import React from "react";
import { motion } from "framer-motion";
import planData from './../data/planData'

const PricingComparation = () => {
  return (
    <div className="relative w-full max-w-4xl mx-auto py-14">
      {/* Background with vibrant purple gradient */}
      <div className="relative rounded-xl p-6 overflow-hidden min-h-[300px]">
        {/* Floating shapes */}
        <motion.div
          className="absolute top-8 left-8 w-12 h-12"
          animate={{ y: [0, -5, 0] }}
          transition={{ repeat: Number.POSITIVE_INFINITY, duration: 3 }}
        >
          <div className="w-full h-full bg-purple-500 opacity-30 rotate-45 transform -rotate-12"></div>
        </motion.div>

        <motion.div
          className="absolute bottom-20 right-8 w-12 h-12"
          animate={{ y: [0, 5, 0] }}
          transition={{ repeat: Number.POSITIVE_INFINITY, duration: 2.5 }}
        >
          <div className="w-full h-full bg-purple-400 opacity-30 rounded-full"></div>
        </motion.div>

        <motion.div
          className="absolute top-1/3 right-12 w-8 h-8"
          animate={{ rotate: 360 }}
          transition={{
            repeat: Number.POSITIVE_INFINITY,
            duration: 10,
            ease: "linear",
          }}
        >
          <div className="w-full h-full border-4 border-purple-300 opacity-30 rounded-full"></div>
        </motion.div>

        {/* Logo */}
        <div className="flex justify-center mb-8 mt-2">
          <div className="flex items-center">
            <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center mr-2">
              <div className="w-8 h-8 bg-purple-600 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-xl">C</span>
              </div>
            </div>
            <h1 className="text-white text-2xl font-bold">Cheaper Course</h1>
          </div>
        </div>

        {/* Comparison cards */}
        <div className="flex flex-col md:flex-row gap-6 justify-center">
          {/* Competitors card */}
          <div className="bg-white rounded-xl p-6 shadow-lg relative flex-1">
            {/* Red X icon */}
            <div className="absolute -top-4 -left-4 w-10 h-10 bg-white rounded-lg shadow-md flex items-center justify-center">
              <div className="text-red-500 font-bold text-2xl">✕</div>
            </div>

            <div className="space-y-5 mt-10">
              <div className="flex items-center">
                <div className="text-red-500 mr-3 text-xl font-bold">✕</div>
                <div>
                  <span className="font-bold text-gray-700">Academind</span>

                  <span className="text-red-500 font-bold ml-2">
                    1.7M/khóa mua lẻ
                  </span>
                </div>
              </div>
              <div className="flex items-center">
                <div className="text-red-500 mr-3 text-xl font-bold">✕</div>
                <div>
                  <span className="font-bold text-gray-700">Academind</span>

                  <span className="text-red-500 font-bold ml-2">
                    625K/tháng |
                  </span>
                  <span className="text-red-500 font-bold ml-2">6.3M/năm</span>
                </div>
              </div>

              <div className="flex items-center">
                <div className="text-red-500 mr-3 text-xl font-bold">✕</div>
                <div>
                  <span className="font-bold text-gray-700">ChrisCourse</span>
                  <span className="text-red-500 font-bold ml-2">
                    375K/tháng |
                  </span>
                  <span className="text-red-500 font-bold ml-2">2.5M/năm</span>
                </div>
              </div>
              <div className="flex items-center">
                <div className="text-red-500 mr-3 text-xl font-bold">✕</div>
                <div>
                  <span className="font-bold text-gray-700">
                    ThreeJsJourney
                  </span>
                  <span className="text-red-500 font-bold ml-2">2.5M</span>
                </div>
              </div>
              <div className="flex justify-center mt-4">
                <div className="relative db">
                  <div className="bg-red-600 text-white px-6 py-3 rounded-xl">
                    <div className="text-2xl font-bold text-center">
                      Tổng chi phí
                    </div>
                    <div className="text-sm font-bold">
                      ~ 1M/tháng | ~ 10M/năm
                    </div>
                  </div>
                  {/* Confetti elements */}
                  <div className="absolute -top-2 -right-2 w-4 h-4 bg-yellow-400 rounded-full"></div>
                  <div className="absolute -bottom-1 -left-1 w-3 h-3 bg-red-400 rounded-full"></div>
                  <div className="absolute top-1 -left-2 w-2 h-2 bg-green-400 rounded-full"></div>
                </div>
              </div>
            </div>
          </div>

          {/* Cheaper Course card */}
          <div className="bg-white rounded-xl p-6 shadow-lg relative flex-1">
            {/* Green check icon */}
            <div className="absolute -top-4 -left-4 w-10 h-10 bg-white rounded-lg shadow-md flex items-center justify-center">
              <div className="text-green-500 font-bold text-2xl">✓</div>
            </div>

            {/* Cartoon character */}
            <div className="absolute -top-10 right-2">
              <div className="relative w-20 h-20">
                <div className="absolute bottom-0 w-12 h-12 bg-yellow-400 rounded-full">
                  <div className="absolute top-1 left-1 w-10 h-5 bg-yellow-300 rounded-full"></div>
                  <div className="absolute top-3 left-3 w-2 h-2 bg-black rounded-full"></div>
                  <div className="absolute top-3 left-7 w-2 h-2 bg-black rounded-full"></div>
                  <div className="absolute top-7 left-5 w-3 h-1 bg-black rounded-full"></div>
                </div>
                <div
                  className="absolute -top-2 left-6 w-0 h-0 
                  border-l-[6px] border-l-transparent
                  border-b-[12px] border-b-green-500
                  border-r-[6px] border-r-transparent"
                ></div>
                <motion.div
                  className="absolute top-2 right-0"
                  animate={{ rotate: [-10, 10, -10] }}
                  transition={{
                    repeat: Number.POSITIVE_INFINITY,
                    duration: 1.5,
                  }}
                >
                  <div className="w-8 h-2 bg-orange-400 rounded-full"></div>
                </motion.div>
              </div>
            </div>

            <div className="mt-4 mb-2 text-center">
              <h2 className="text-purple-800 font-bold text-xl">
                Cheaper Course
              </h2>
            </div>

            {/* Price tag */}
            {
              planData.map((item, index) => {
                return <div className="flex justify-center mt-4">

                  <div className="relative db">
                    <div className="bg-purple-600 text-white px-6 py-3 rounded-xl">
                      {/* <div className="text-sm font-bold">Sở hữu toàn bộ khóa học</div> */}
                      <div className="text-3xl font-bold">{index === 0 && "Mua lẻ:"} {item.price}{index !== 2 ? "/" + item.duration : " trọn đời"}</div>
                    </div>
                    {/* Confetti elements */}
                    <div className="absolute -top-2 -right-2 w-4 h-4 bg-yellow-400 rounded-full"></div>
                    <div className="absolute -bottom-1 -left-1 w-3 h-3 bg-red-400 rounded-full"></div>
                    <div className="absolute top-1 -left-2 w-2 h-2 bg-green-400 rounded-full"></div>
                  </div>
                </div>
              })
            }

          </div>
        </div>

        {/* Bottom characters */}
        <div className="flex justify-between mt-8">
          {/* Left character */}
          <div className="relative w-16 h-16">
            <div className="absolute bottom-0 w-8 h-12 bg-purple-300 rounded-t-full"></div>
            <div className="absolute bottom-12 left-1 w-6 h-6 bg-purple-400 rounded-full">
              <div className="absolute top-1 left-1 w-4 h-2 bg-purple-300 rounded-full"></div>
              <div className="absolute top-2 left-1 w-1 h-1 bg-black rounded-full"></div>
              <div className="absolute top-2 left-4 w-1 h-1 bg-black rounded-full"></div>
            </div>
          </div>

          {/* Middle character - pink */}
          <div className="relative w-16 h-16">
            <motion.div
              className="absolute bottom-0"
              animate={{ y: [0, -3, 0] }}
              transition={{ repeat: Number.POSITIVE_INFINITY, duration: 2 }}
            >
              <div className="relative w-12 h-12">
                <div className="absolute bottom-0 w-10 h-4 bg-pink-400 rounded-full"></div>
                <div className="absolute bottom-4 w-10 h-8 bg-pink-400 rounded-full">
                  <div className="absolute top-2 left-2 w-1 h-1 bg-black rounded-full"></div>
                  <div className="absolute top-2 left-6 w-1 h-1 bg-black rounded-full"></div>
                  <div className="absolute top-4 left-4 w-2 h-1 bg-black rounded-full"></div>
                </div>
              </div>
            </motion.div>
            <div className="absolute top-0 right-0 text-red-500 text-lg">
              ❤️
            </div>
          </div>

          {/* Right character - man with beard */}
          <div className="relative w-16 h-16">
            <div className="absolute bottom-0 right-0">
              <div className="relative w-14 h-14">
                <div className="absolute bottom-0 right-0 w-10 h-6 bg-red-700 rounded-t-lg"></div>
                <div className="absolute bottom-6 right-1 w-8 h-8 bg-[#FFD3B4] rounded-full">
                  <div className="absolute bottom-0 w-8 h-4 bg-brown-500 rounded-b-full"></div>
                  <div className="absolute top-2 left-2 w-1 h-1 bg-black rounded-full"></div>
                  <div className="absolute top-2 left-5 w-1 h-1 bg-black rounded-full"></div>
                </div>
                <motion.div
                  className="absolute -right-2 bottom-2"
                  animate={{ rotate: [0, 10, 0] }}
                  transition={{ repeat: Number.POSITIVE_INFINITY, duration: 2 }}
                >
                  <div className="w-4 h-8 bg-[#FFD3B4] rounded-full"></div>
                  <div className="absolute top-0 w-4 h-4 bg-[#FFD3B4] rounded-full">
                    👍
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingComparation;
